import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  cod: string
}

type Response = IUserTicketData

export const getData = async (props: Props): Promise<Response> => {
  const { cod } = props

  const endpoint = ApiEndpoint.v4.ticket.data(cod)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
